var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 187,
    viewBox: "0 0 197 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2226 163.15C8.48543 158.621 5.48315 153.038 6.22161 147.21C6.96676 141.325 10.9456 136.254 11.8361 130.39C12.8909 123.44 9.50062 116.7 6.76167 110.228C1.81507 98.5385 -1.28048 85.7036 0.514911 73.1361C2.3103 60.5685 9.63872 48.3493 21.1335 42.996C28.6619 39.4902 37.3348 39.0934 44.8905 35.6475C52.5755 32.1423 58.5141 25.7749 65.253 20.6781C75.4631 12.956 87.9092 8.05117 100.692 7.49999C113.475 6.94882 126.532 10.8912 136.423 19.0199C147.7 28.2877 154.234 42.211 158.015 56.3211C160.052 63.9266 161.409 71.7519 164.342 79.0581C169.883 92.8658 180.622 103.843 188.385 116.532C196.148 129.221 200.728 145.95 193.034 158.681C187.324 168.129 176.347 172.898 165.798 176.116C141.741 183.455 116.432 185.724 91.2954 186.499C70.4073 187.145 25.5159 179.262 12.2226 163.15Z",
    fill: "#EAD795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.904 158.564H82.7734",
    stroke: "#CCC19C",
    strokeWidth: 5.86546,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5431 159.012H9.32617",
    stroke: "#CCC19C",
    strokeWidth: 4.18959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.788 159.012H129.109",
    stroke: "#CCC19C",
    strokeWidth: 4.18959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.219 178.212H92.0918",
    stroke: "#CCC19C",
    strokeWidth: 4.18959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180.543 159.012H152.621",
    stroke: "#CCC19C",
    strokeWidth: 4.18959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.567 142.911H19.3984",
    stroke: "#CCC19C",
    strokeWidth: 5.58807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.003 168.387H79.9883",
    stroke: "#CCC19C",
    strokeWidth: 4.18959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8075 168.387H31.9551",
    stroke: "#CCC19C",
    strokeWidth: 4.18959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1562 90.9668L63.4077 91.6763L64.067 95.9309L60.6321 95.4546L60.1562 90.9668Z",
    fill: "#E19259"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7973 91.2423L60.634 95.4545C60.634 95.4545 58.0981 97.7613 55.5414 96.2277C55.5414 96.2277 54.2656 95.6977 55.1854 94.1635C55.1854 94.1635 54.9397 94.0599 54.7243 93.7353C54.3683 93.1987 54.609 92.686 55.0059 92.1793L55.5343 91.7146C55.5343 91.7146 54.6408 90.5425 56.0066 89.6394C57.3719 88.7358 59.9852 89.7607 60.7973 91.2423Z",
    fill: "#E19259"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6887 88.7121C91.6435 87.4368 89.7624 87.2507 88.4876 88.2954C88.387 88.3784 77.5693 95.04 62.2265 90.8789C62.0708 90.8364 61.9256 90.7727 61.7734 90.7368L62 97.0707C66.1282 98.6671 70.8466 98.8411 74.3159 98.8411C84.8777 98.8411 91.8827 92.8004 92.272 92.4808C93.5473 91.4351 93.7339 89.9869 92.6887 88.7121Z",
    fill: "#F7ECE4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.228 36.4726C108.784 35.389 105.901 33.5681 97.6345 34.1031C96.8811 34.1516 96.1292 34.2512 95.3869 34.3964C92.3266 34.9956 82.9172 36.7512 77.9961 36.7047C72.8494 36.6562 63.1114 34.5779 57.4141 34.1016V49.7139C57.4141 49.7139 70.046 53.6854 84.9747 49.7882C99.9029 45.8911 107.486 50.6003 116.161 51.0873C124.836 51.5742 130.133 49.7882 130.133 49.7882V35.5923C128.389 36.376 125.139 37.086 119.228 36.4726Z",
    fill: "#006837"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6583 20.6488C84.2658 23.9938 94.8994 19.4827 102.66 18.7819C108.226 18.2787 114.356 20.4349 119.513 21.0103C123.437 21.4482 127.291 21.1833 130.133 20.8172V7.08235C126.885 4.71939 120.648 4.25418 116.241 4.25367C113.644 4.25367 111.057 4.54847 108.513 5.10318C102.288 6.46038 87.0166 9.17378 77.5066 5.62453C65.3343 1.08165 57.4141 5.62453 57.4141 5.62453V18.9892C60.1249 18.6266 65.2261 18.5068 72.6583 20.6488Z",
    fill: "#F7931E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9956 36.7043C82.9172 36.7508 92.3261 34.9951 95.3863 34.3959C96.1287 34.2508 96.8806 34.1512 97.634 34.1026C105.9 33.5677 108.783 35.3891 119.228 36.4722C125.139 37.0851 128.389 36.3756 130.133 35.5918V20.8158C127.291 21.1819 123.436 21.4469 119.513 21.009C114.356 20.4336 108.226 18.2774 102.66 18.7805C94.8994 19.4819 84.2658 23.9924 72.6583 20.6475C65.2261 18.506 60.1249 18.6253 57.4141 18.9884V34.1011C63.1109 34.5775 72.8489 36.6557 77.9956 36.7043Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.719 84.1601H104.385C105.835 84.1601 107.045 83.0577 107.177 81.6146C107.538 77.6608 108.255 70.1977 108.783 67.2947C108.783 65.6745 107.47 64.3613 105.85 64.3613H103.283L100.35 65.8277L102.719 84.1601Z",
    fill: "#52211B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.116 79.3603V89.0554H92.832V79.2627L103.116 79.3603Z",
    fill: "#D38550"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.154 68.3945L85.9521 77.0095C85.4247 80.7878 88.359 84.1601 92.1743 84.1601H100.427C102.006 84.1601 103.287 82.8803 103.287 81.3011V68.3945H87.154Z",
    fill: "#E19259"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.057 76.8822C107.057 78.3395 105.876 79.5213 104.418 79.5213C102.961 79.5213 101.779 78.3395 101.779 76.8822C101.779 75.4249 102.961 74.2432 104.418 74.2432C105.876 74.2437 107.057 75.4249 107.057 76.8822Z",
    fill: "#E19259"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.282 74.9956V78.2956H101.816L100.35 72.4289L101.083 68.3962L104.749 67.2959L103.282 74.9956Z",
    fill: "#52211B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7852 73.8423C92.7852 74.266 93.1285 74.6094 93.5522 74.6094C93.976 74.6094 94.3193 74.266 94.3193 73.8423C94.3193 73.4185 93.976 73.0752 93.5522 73.0752C93.1285 73.0752 92.7852 73.4185 92.7852 73.8423Z",
    fill: "#52211B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2734 73.8423C87.2734 74.266 87.6168 74.6094 88.0405 74.6094C88.4643 74.6094 88.8076 74.266 88.8076 73.8423C88.8076 73.4185 88.4643 73.0752 88.0405 73.0752C87.6173 73.0752 87.2734 73.4185 87.2734 73.8423Z",
    fill: "#52211B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.02 72.3945H95.8555V70.7749H92.02V72.3945Z",
    fill: "#52211B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1249 72.3945H89.5938V70.7749H86.1249V72.3945Z",
    fill: "#52211B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8401 74.9434L88.9141 77.1925H90.8229L90.8401 74.9434Z",
    fill: "#CB7B46"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6613 68.396H103.142C105.043 68.396 106.585 66.8548 106.585 64.9535V64.1389C106.585 62.2376 105.043 60.6963 103.142 60.6963H87.6613C85.76 60.6963 84.2188 62.2376 84.2188 64.1389V64.9535C84.2188 66.8548 85.76 68.396 87.6613 68.396Z",
    fill: "#52211B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5808 68.397C90.2132 68.397 92.3472 66.263 92.3472 63.6306C92.3472 60.9982 90.2132 58.8643 87.5808 58.8643C84.9484 58.8643 82.8145 60.9982 82.8145 63.6306C82.8145 66.263 84.9484 68.397 87.5808 68.397Z",
    fill: "#52211B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6445 66.6225C97.704 65.7743 98.6859 63.4171 97.8377 61.3576C96.9895 59.2981 94.6323 58.3161 92.5728 59.1644C90.5133 60.0126 89.5314 62.3698 90.3796 64.4293C91.2278 66.4888 93.585 67.4707 95.6445 66.6225Z",
    fill: "#52211B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.194 63.3723C103.661 61.4018 102.442 59.426 100.471 58.9593C98.5006 58.4925 96.5248 59.7115 96.058 61.6821C95.5913 63.6526 96.8103 65.6284 98.7808 66.0951C100.751 66.5619 102.727 65.3429 103.194 63.3723Z",
    fill: "#52211B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.388 78.3672H87.584C87.584 78.3672 89.9232 81.8229 93.388 78.3672Z",
    fill: "#F0ECE7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0377 155.847V160.189H86.7734C86.7734 160.189 85.5381 156.069 92.3317 155.847H96.0377Z",
    fill: "#4A2037"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M106.665 155.847V160.189H97.4003C97.4003 160.189 96.165 156.069 102.959 155.847H106.665Z",
    fill: "#4A2037"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M106.638 151.156H103.451V155.846H106.638V151.156Z",
    fill: "#E19259"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0402 151.156H92.8535V155.846H96.0402V151.156Z",
    fill: "#E19259"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0032 118.922V152.435H88.8655L87.5078 117.217L97.0032 118.922Z",
    fill: "#FF9331"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8496 110.117H108.762L107.168 152.435H99.0306L98.3025 121.906L92.5056 119.465C90.3868 119.15 88.8496 117.666 88.8496 115.936V110.117Z",
    fill: "#FF9331"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M110.117 122.979H86.2363L86.6869 93.0816C86.6869 89.8094 89.289 87.1572 92.4995 87.1572H103.854C107.064 87.1572 109.667 89.8094 109.667 93.0816L110.117 122.979Z",
    fill: "#F7ECE4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M110.117 120.684H86.2363V122.98H110.117V120.684Z",
    fill: "#FEC04B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0985 86.2363H94.5039V89.2091H97.0985V86.2363Z",
    fill: "#D38550"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0531 155.849H56.0957V0.978963C56.0957 0.438409 56.5336 0 57.0742 0C57.6147 0 58.0526 0.438409 58.0526 0.978963L58.0531 155.849Z",
    fill: "#8E866E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0223 160.192H49.1025C47.9035 160.192 46.9316 159.22 46.9316 158.021C46.9316 156.822 47.9035 155.851 49.1025 155.851H65.0223C66.2212 155.851 67.1936 156.822 67.1936 158.021C67.1931 159.22 66.2212 160.192 65.0223 160.192Z",
    fill: "#CCC19C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M111.394 106.745L114.146 110.714C114.146 110.714 114.135 113.086 111.365 113.598C111.365 113.598 110.13 114.02 109.822 112.359C109.822 112.359 109.583 112.439 109.228 112.343C108.64 112.186 108.49 111.672 108.454 111.065L108.538 110.406C108.538 110.406 107.172 110.134 107.574 108.64C107.978 107.147 109.893 106.204 111.394 106.745Z",
    fill: "#E19259"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M124.133 100.896C124.878 99.4794 124.374 97.7278 122.99 96.9238L107.023 87.792C105.598 86.9638 103.77 87.4487 102.943 88.8747C102.115 90.3006 102.6 92.1271 104.026 92.9549L117.083 100.216L111.609 106.435C111.55 106.546 111.439 106.634 111.396 106.748C111.396 106.748 113.663 111.341 115.398 112.242C115.457 112.154 115.516 112.066 115.567 111.97L124.133 100.896Z",
    fill: "#F7ECE4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3784 105.757H92.8813L93.1174 92.7837L87.627 88.7723L88.9093 88.0169L94.5075 92.0935L94.284 104.379H97.0004V92.3514L103.2 87.1572H105.037L98.3784 92.9855V105.757Z",
    fill: "#FEC04B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4531 90.8206C57.4531 90.8206 57.8678 90.7245 59.2452 91.2373",
    stroke: "#E19259",
    strokeWidth: 3.22507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9379 22.5787C88.3538 22.7633 85.5736 25.3543 85.7289 28.366C85.8836 31.3778 88.915 33.6699 92.4992 33.4854C96.0833 33.3008 98.8635 30.7098 98.7082 27.698C98.553 24.6863 95.522 22.3947 91.9379 22.5787ZM92.4638 32.8037C89.3277 32.965 86.6755 30.9596 86.5394 28.3241C86.4039 25.6885 88.8362 23.4217 91.9728 23.2603C95.1089 23.099 97.7611 25.1045 97.8971 27.74C98.0327 30.375 95.5999 32.6424 92.4638 32.8037Z",
    fill: "#262678"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2664 28.9417C92.8636 28.9108 93.3273 28.479 93.3015 27.9769C93.2757 27.4747 92.7705 27.093 92.1728 27.1238C91.5756 27.1547 91.112 27.5865 91.1377 28.0886C91.164 28.5907 91.6692 28.9725 92.2664 28.9417Z",
    fill: "#262678"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9844 23.4873L92.6539 25.959L92.1715 27.1225L91.5723 26.0146L91.9844 23.4873Z",
    fill: "#262678"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8779 24.6201L94.2649 26.7975L92.9512 27.3482L93.467 26.1937L95.8779 24.6201Z",
    fill: "#262678"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6311 27.7506L94.6801 28.3584L93.3047 27.9736L94.6331 27.4492L97.6311 27.7506Z",
    fill: "#262678"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 31.0497L93.6467 29.732L93.0156 28.6367L94.3789 29.0498L96.2069 31.0497Z",
    fill: "#262678"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4508 32.5781L91.7812 30.1064L92.2637 28.9424L92.8629 30.0508L92.4508 32.5781Z",
    fill: "#262678"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5566 31.44L90.1702 29.2626L91.4834 28.7119L90.9676 29.8658L88.5566 31.44Z",
    fill: "#262678"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8125 28.3104L89.7636 27.7031L91.139 28.0879L89.8106 28.6118L86.8125 28.3104Z",
    fill: "#262678"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2285 25.0176L90.7887 26.3358L91.4203 27.4311L90.057 27.018L88.2285 25.0176Z",
    fill: "#262678"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoist);
export default __webpack_public_path__ + "static/media/hoist.b06d07f98c6519da96a35e5c20a165fb.svg";
export { ForwardRef as ReactComponent };